export default {"src":"/_next/static/media/card_bg_formation.89492c91.svg","height":435,"width":1031};